// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/update_experiment_data_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldMask } from "../../../../google/protobuf/field_mask_pb";
import { file_google_protobuf_field_mask } from "../../../../google/protobuf/field_mask_pb";
import type { ExperimentData } from "./experiment_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_data } from "./experiment_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/update_experiment_data_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_update_experiment_data_request: GenFile = /*@__PURE__*/
  fileDesc("CkxxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvdXBkYXRlX2V4cGVyaW1lbnRfZGF0YV9yZXF1ZXN0LnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEizgEKG1VwZGF0ZUV4cGVyaW1lbnREYXRhUmVxdWVzdBJVCg9leHBlcmltZW50X2RhdGEYASABKAsyNy5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuRXhwZXJpbWVudERhdGFIAIgBARI0Cgt1cGRhdGVfbWFzaxgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2tIAYgBAUISChBfZXhwZXJpbWVudF9kYXRhQg4KDF91cGRhdGVfbWFza2IGcHJvdG8z", [file_google_protobuf_field_mask, file_quanterix_simoa_one_analysis_app_api_v1_experiment_data]);

/**
 * Rpc request to save a created or modified experiment as a new experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.UpdateExperimentDataRequest
 */
export type UpdateExperimentDataRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.UpdateExperimentDataRequest"> & {
  /**
   * Updated experiment data to be saved
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentData experiment_data = 1;
   */
  experimentData?: ExperimentData;

  /**
   * Represents a set of field paths to be modified by the update request. If
   * omitted, all fields all fields in assay_data are updated in storage.
   *
   * See: https://protobuf.dev/reference/protobuf/google.protobuf/#field-mask
   *
   * @generated from field: optional google.protobuf.FieldMask update_mask = 2;
   */
  updateMask?: FieldMask;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.UpdateExperimentDataRequest.
 * Use `create(UpdateExperimentDataRequestSchema)` to create a new message.
 */
export const UpdateExperimentDataRequestSchema: GenMessage<UpdateExperimentDataRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_update_experiment_data_request, 0);

